import { createSlice } from "@reduxjs/toolkit";
import axiosServices from "../../utils/axios";
import { dispatch } from "../index";

// ----------------------------------------------------------------------

export const initialState = {
  error: null,
};

const slice = createSlice({
  name: "sitesMap",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },
    updateSiteById(state, action) {
      state[action?.payload?.id] = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

export function getSiteById(id) {
  return async () => {
    try {
      const response = await axiosServices.get(
        `${process.env.REACT_APP_SERVICES_API}/services/site/${id}`,
      );
      dispatch(slice.actions.updateSiteById(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
